import * as actions from '../actions/actionTypes';

const initialState = {
  departments: [],
  department: null
}

const fetchDepartmentsSuccess = (state, action) => {
  return { ...state, departments: action.departments }
}

const fetchDepartmentSuccess = (state, action) => {
  return { ...state, department: action.department }
}

const createDepartmentSuccess = (state, action) => {
  return {
    ...state,
    departments: state.departments.concat(action.department)
  }
}

const updateDepartmentSuccess = (state, action) => {
  const newDepartments = state.departments.map(
    (department) => {
      if (department.id === action.department.id) {
        return action.department;
      }
      return department;
    });

  return {
    ...state,
    departments: newDepartments
  };
}

const deleteDepartmentSuccess = (state, action) => {
  const newDepartments = state.departments.filter(
    (department) => department.id !== action.id
  );
  return {
    ...state,
    departments: newDepartments
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_DEPARTMENTS_SUCCESS: return fetchDepartmentsSuccess(state, action);
    case actions.FETCH_DEPARTMENT_SUCCESS: return fetchDepartmentSuccess(state, action);
    case actions.CREATE_DEPARTMENT_SUCCESS: return createDepartmentSuccess(state, action);
    case actions.UPDATE_DEPARTMENT_SUCCESS: return updateDepartmentSuccess(state, action);
    case actions.DELETE_DEPARTMENT_SUCCESS: return deleteDepartmentSuccess(state, action);

    default: return state;
  }
}

export default reducer;